import { Box, Button, Modal, Typography } from "@mui/material";
import { useContext } from "react";
import { LogOut } from "lucide-react";

import { PatientsListContext } from "../../components/PatientsList/PatientsList";
import { URI_API, getHeaders } from "../../utils/config";
import "./AltaPatientModal.scss";

export default function AltaModal() {
	const {
		openAltaModal,
		handleCloseAltaModal,
		selectedPatient,
		setOpenConfirmationModal,
		setConfirmationTitle,
		updatePatients
	} = useContext(PatientsListContext);

	const altaPatient = (id: any) => {
		fetch(`${URI_API}/patients`, getHeaders("DELETE", { id }))
			.then((res) => res.json())
			.then(handleCloseAltaModal)
			.then(setConfirmationTitle("Alta de Paciente"))
			.then(setOpenConfirmationModal(true));
		updatePatients();
	};

	return (
		<>
			<Modal
				open={openAltaModal}
				onClose={handleCloseAltaModal}
			>
				<Box className="altamodal">
					<Box className="altamodal__header">
						<img
							className="altamodal__header-grain"
							src={require("../../assets/images/grain.png")}
							alt="background"
						/>
						<Box className="altamodal__header__title-container">
							<LogOut
								size={25}
								className="altamodal__header__title-container-icon"
							/>
							<Box>
								<Typography className="altamodal__header__title-container__text-title">
									Dar de alta
								</Typography>
								<Typography className="altamodal__header__title-container__text-subtitle">
									¿Está seguro de que desea eliminar al siguiente paciente?
								</Typography>
							</Box>
						</Box>
					</Box>
					<Box className="altamodal__body">
						<Box className="altamodal__body__label">
							<Typography className="altamodal__body__label-text">ID:</Typography>
							<Typography className="altamodal__body__label-text">
								Paciente:
							</Typography>
							<Typography className="altamodal__body__label-text">
								Fecha de admisión:
							</Typography>
						</Box>
						<Box className="altamodal__body__data">
							<Typography className="altamodal__body__data-text">
								{selectedPatient?.patient_number}
							</Typography>
							<Box sx={{ display: "flex", flexDirection: "row" }}>
								<Typography className="altamodal__body__data-text">
									{selectedPatient?.name}
								</Typography>
								<Typography
									className="altamodal__body__label-text"
									sx={{ marginLeft: "30px" }}
								>
									Cama:
								</Typography>
								<Typography
									className="altamodal__body__data-text"
									sx={{ marginLeft: "10px" }}
								>
									{selectedPatient?.room}
								</Typography>
							</Box>
							<Typography className="altamodal__body__data-text">
								{selectedPatient?.date_of_admission}
							</Typography>
						</Box>
					</Box>
					<Box className="altamodal__buttons">
						<Button
							className="altamodal__buttons__close"
							onClick={handleCloseAltaModal}
						>
							Cerrar
						</Button>
						<Button
							className="altamodal__buttons__logout"
							onClick={() => altaPatient(selectedPatient.id)}
						>
							<LogOut /> Dar de alta
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
}
